<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>{{
        $t("admissions.entries.page_title")
      }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-layout row wrap justify-end align-end>
        <v-dialog
          v-model="dialogFamily"
          transition="dialog-transition"
          max-width="600px"
          @activated="getFamiliesToCreate()"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="blue darken-1" flat v-on="on"
              >1. Crear Familias</v-btn
            >
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Crear Familias</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items> </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <span v-if="loadingFamilies === true">Loading Families...</span>
              <ul v-if="loadingFamilies === false">
                <li v-for="(item, index) in familiesToCreate" :key="index">
                  {{ item.family_name }}
                </li>
                <li v-if="familiesToCreate.length === 0">
                  No hay familias para crear
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="familiesToCreate.length !== 0"
                color="primary"
                @click="createFamilies"
                >Enviar</v-btn
              >
              <v-btn color="error" @click="handleDialogFamily()">{{
                $t("admissions.entries.form.cancel")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--  -->
        <v-dialog
          v-model="dialogInvitation"
          transition="dialog-transition"
          max-width="600px"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="blue darken-1" flat v-on="on"
              >2. Enviar Invitación</v-btn
            >
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Enviar Invitaciones</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items> </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <span v-if="loadingFamiliesInvitation">Loading Families...</span>
              <ul v-if="!loadingFamiliesInvitation">
                <li v-for="(item, index) in familiesInvitation" :key="index">
                  {{ item.family_name }}
                </li>
                <li v-if="familiesInvitation.length === 0">
                  No hay invitaciones por enviar.
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="familiesInvitation.length !== 0"
                color="primary"
                @click="sendInvitation"
                >Enviar</v-btn
              >
              <v-btn color="error" @click="handleDialogInvitation()">{{
                $t("admissions.entries.form.cancel")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--  -->
        <v-dialog
          v-model="dialogCouncil"
          transition="dialog-transition"
          max-width="600px"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="blue darken-1" flat v-on="on"
              >3. Invitación Consejería</v-btn
            >
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Enviar Invitaciones</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items> </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <ul>
                <li
                  v-for="(item, index) in familiesCouncilInvitation"
                  :key="index"
                >
                  {{ item.family_name }}
                </li>
                <li v-if="familiesCouncilInvitation.length === 0">
                  No hay invitaciones de consejería por enviar.
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="familiesCouncilInvitation.length !== 0"
                color="primary"
                @click="sendCouncilInvitation"
                >Enviar</v-btn
              >
              <v-btn color="error" @click="handleDialogCouncil()">{{
                $t("admissions.entries.form.cancel")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--  -->
        <!-- <v-dialog v-model="dialogCouncil" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="blue darken-1" flat v-on="on"
              >3. Invitación Consejería</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span
                >¿Estás seguro/a de enviar todas las invitaciones de
                consejería?</span
              >
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click="handleDialogCouncil()"
                >{{ $t("admissions.entries.form.cancel") }}</v-btn
              >
              <v-btn color="blue darken-1" flat @click="sendCouncilInvitation"
                >Enviar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog> -->

        <download-excel
          class="v-btn v-btn--floating v-btn--small theme--dark primary"
          :data="entries_to_show"
          name="admissions_entries.xls"
        >
          <v-icon color="white">cloud_download</v-icon>
        </download-excel>
      </v-layout>
    </v-toolbar>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span v-show="!editingEntry" class="headline">{{
            $t("admissions.entries.new_type")
          }}</span>
          <span v-show="editingEntry" class="headline">{{
            $t("admissions.entries.edit_type")
          }}</span>
        </v-card-title>

        <v-card-text>
          <div>Tipo de familia</div>
          <v-layout row>
            <v-flex xs4 px-1>
              <v-checkbox
                label="Staff"
                color="primary"
                type="checkbox"
                v-model="form.staff"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox
                label="Vinculada"
                color="primary"
                type="checkbox"
                v-model="form.vinculada"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox
                label="Egresado"
                color="primary"
                type="checkbox"
                v-model="egresado"
                disabled
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs4 px-1>
              <v-checkbox
                label="Expatriado"
                color="primary"
                type="checkbox"
                v-model="form.expatriado"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox
                label="Multicultural"
                color="primary"
                type="checkbox"
                v-model="form.multicultural"
              ></v-checkbox>
            </v-flex>
          </v-layout>

          <v-text-field
            :label="$t('admissions.form.first_name')"
            :v-errors="errors"
            v-model="form.first_name"
            name="first_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :label="$t('admissions.form.last_name')"
            :v-errors="errors"
            v-model="form.last_name"
            name="last_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :label="$t('admissions.form.nuip')"
            :v-errors="errors"
            v-model="form.nuip"
            name="nuip"
            v-validate="'required'"
          ></v-text-field>

          <date-picker
            :form="form"
            :label="$t('admissions.form.date_of_birth')"
            :v-errors="errors"
            v-model="form.date_of_birth"
            name="date_of_birth"
            v-validate="'required'"
          ></date-picker>

          <div>{{ $t("admissions.form.twin") }}</div>

          <v-radio-group
            :form="form"
            :value.sync="form.twin"
            v-model="form.twin"
            row
            :disabled="disabled_date"
          >
            <v-radio
              :label="$t('admissions.form.yesno_options.yes')"
              value="Si"
              name="twin"
              :color="'primary'"
            ></v-radio>
            <v-radio
              :label="$t('admissions.form.yesno_options.no')"
              value="No"
              name="twin"
              :color="'primary'"
            ></v-radio>
          </v-radio-group>

          <div v-if="form.twin === 'Si'">
            <v-text-field
              :form="form"
              :label="$t('admissions.form.twin_first_name')"
              :v-errors="errors"
              v-model="form.twin_first_name"
              name="twin_first_name"
            ></v-text-field>

            <v-text-field
              :form="form"
              :label="$t('admissions.form.twin_last_name')"
              :v-errors="errors"
              v-model="form.twin_last_name"
              name="twin_last_name"
            ></v-text-field>

            <v-text-field
              :form="form"
              :label="$t('admissions.form.twin_nuip')"
              :v-errors="errors"
              v-model="form.twin_nuip"
              name="twin_nuip"
            ></v-text-field>

            <div>
              <strong>{{ $t("admissions.form.twin_gender") }}</strong>
            </div>

            <v-radio-group v-model="form.twin_gender" row>
              <v-radio
                :label="$t('admissions.form.gender_options.m')"
                value="m"
                name="twin_gender"
                :color="'primary'"
              ></v-radio>
              <v-radio
                :label="$t('admissions.form.gender_options.f')"
                value="f"
                name="twin_gender"
                :color="'primary'"
              ></v-radio>
            </v-radio-group>
          </div>

          <div>{{ $t("admissions.form.gender") }}</div>

          <v-radio-group v-model="form.gender" row :disabled="disabled_date">
            <v-radio
              :label="$t('admissions.form.gender_options.m')"
              value="m"
              name="gender"
              :color="'primary'"
            ></v-radio>
            <v-radio
              :label="$t('admissions.form.gender_options.f')"
              value="f"
              name="gender"
              :color="'primary'"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_first_name')"
            :v-errors="errors"
            v-model="form.guardian1_first_name"
            name="guardian1_first_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_last_name')"
            :v-errors="errors"
            v-model="form.guardian1_last_name"
            name="guardian1_last_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_id')"
            :v-errors="errors"
            v-model="form.guardian1_id"
            name="guardian1_id"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_cellphone')"
            :v-errors="errors"
            v-model="form.guardian1_cellphone"
            name="guardian1_cellphone"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_email')"
            :v-errors="errors"
            v-model="form.guardian1_email"
            name="guardian1_email"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_relation')"
            :v-errors="errors"
            v-model="form.guardian1_relation"
            name="guardian1_relation"
            v-validate="'required'"
          ></v-text-field>

          <v-radio-group
            :form="form"
            :label="$t('admissions.form.guardian1_graduate')"
            v-model="guardian1_graduate"
            row
          >
            <v-radio
              :label="$t('admissions.form.yesno_options.yes')"
              value="Si"
              name="guardian1_graduate"
              :color="'primary'"
            ></v-radio>
            <v-radio
              :label="$t('admissions.form.yesno_options.no')"
              value="No"
              name="guardian1_graduate"
              :color="'primary'"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_profession')"
            :v-errors="errors"
            v-model="form.guardian1_profession"
            name="guardian1_profession"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_ocupation')"
            :v-errors="errors"
            v-model="form.guardian1_ocupation"
            name="guardian1_ocupation"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian1_company')"
            :v-errors="errors"
            v-model="form.guardian1_company"
            name="guardian1_company"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_first_name')"
            :v-errors="errors"
            v-model="form.guardian2_first_name"
            name="guardian2_first_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_last_name')"
            :v-errors="errors"
            v-model="form.guardian2_last_name"
            name="guardian2_last_name"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_id')"
            :v-errors="errors"
            v-model="form.guardian2_id"
            name="guardian2_id"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_cellphone')"
            :v-errors="errors"
            v-model="form.guardian2_cellphone"
            name="guardian2_cellphone"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_email')"
            :v-errors="errors"
            v-model="form.guardian2_email"
            name="guardian2_email"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_relation')"
            :v-errors="errors"
            v-model="form.guardian2_relation"
            name="guardian2_relation"
            v-validate="'required'"
          ></v-text-field>

          <v-radio-group
            :form="form"
            :label="$t('admissions.form.guardian2_graduate')"
            v-model="guardian2_graduate"
            row
          >
            <v-radio
              :label="$t('admissions.form.yesno_options.yes')"
              value="Si"
              name="guardian2_graduate"
              :color="'primary'"
            ></v-radio>
            <v-radio
              :label="$t('admissions.form.yesno_options.no')"
              value="No"
              name="guardian2_graduate"
              :color="'primary'"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_profession')"
            :v-errors="errors"
            v-model="form.guardian2_profession"
            name="guardian2_profession"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_ocupation')"
            :v-errors="errors"
            v-model="form.guardian2_ocupation"
            name="guardian2_ocupation"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.guardian2_company')"
            :v-errors="errors"
            v-model="form.guardian2_company"
            name="guardian2_company"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.first_language')"
            :v-errors="errors"
            v-model="form.first_language"
            name="first_language"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.tcs_description')"
            :v-errors="errors"
            v-model="form.tcs_description"
            name="tcs_description"
            v-validate="'required'"
          ></v-text-field>

          <v-text-field
            :form="form"
            :disabled="disabled_date"
            :label="$t('admissions.form.question')"
            :v-errors="errors"
            v-model="form.question"
            name="question"
            v-validate="'required'"
          ></v-text-field>

          <text-area-input
            :form="form"
            :label="$t('admissions.entries.form.notes')"
            :v-errors="errors"
            :value.sync="form.notes"
            name="notes"
          ></text-area-input>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">{{
            $t("admissions.entries.form.cancel")
          }}</v-btn>
          <v-btn
            v-if="!editingEntry"
            color="blue darken-1"
            flat
            @click="saveEntry"
            >{{ $t("admissions.entries.form.save") }}</v-btn
          >
          <v-btn v-else color="blue darken-1" flat @click="updateEntry">{{
            $t("admissions.entries.form.update")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogReport"
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogReport = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title
            >Reporte General Familia {{ report.last_name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs9 px-1>
              <h2 class="font-weight-regular">Información del aspirante</h2>
              <v-layout row>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.vinculada") }}</h3>
                  {{ report.vinculada }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.first_name") }}</h3>
                  {{ report.first_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.last_name") }}</h3>
                  {{ report.last_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.date_of_birth") }}</h3>
                  {{ report.date_of_birth }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.place_of_birth") }}</h3>
                  {{ report.place_of_birth }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.doc_type") }}</h3>
                  {{ report.document_type }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.nuip") }}</h3>
                  {{ report.nuip }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.rc") }}</h3>
                  <a v-if="report.rc" :href="report.rc" target="_blank"
                    >Descargar</a
                  >
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs3 px-1>
                  <h3>Foto</h3>
                  <a v-if="report.photo" :href="report.photo" target="_blank"
                    >Descargar</a
                  >
                </v-flex>
                <!-- <v-layout xs3 px v-if="">

                     </v-layout> -->
                <v-flex v-if="report.system_grade" xs3 px-1>
                  <h3>Grado Sistema</h3>
                  <p v-if="report.system_grade == report.selected_grade">
                    {{ report.system_grade }}
                  </p>
                  <p v-else style="color:red">{{ report.system_grade }}</p>
                </v-flex>
                <v-flex v-if="report.selected_grade" xs3 px-1>
                  <h3>Grado Seleccionado</h3>
                  <p v-if="report.system_grade == report.selected_grade">
                    {{ report.selected_grade }}
                  </p>
                  <p v-else style="color:red">{{ report.selected_grade }}</p>
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.twin") }}</h3>
                  {{ report.twin }}
                </v-flex>
              </v-layout>
              <v-layout row v-if="report.twin == 'Si'">
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.twin_first_name") }}</h3>
                  {{ report.twin_first_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.twin_last_name") }}</h3>
                  {{ report.twin_last_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.twin_nuip") }}</h3>
                  {{ report.twin_nuip }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.twin_gender") }}</h3>
                  {{ report.twin_gender }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.gender") }}</h3>
                  {{ report.gender }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.home_address") }}</h3>
                  {{ report.address }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.religion") }}</h3>
                  {{ report.religion }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.nationality") }}</h3>
                  {{ report.nationality }}
                </v-flex>
              </v-layout>

              <hr class="my-3" />
              <h2 class="font-weight-regular">Información del Acudiente 1</h2>

              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_first_name") }}
                  </h3>
                  {{ report.guardian1_first_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_last_name") }}
                  </h3>
                  {{ report.guardian1_last_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_relation") }}
                  </h3>
                  {{ report.guardian1_relation }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.doc_type") }}</h3>
                  {{ report.guardian1_document_type }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian1_id") }}</h3>
                  {{ report.guardian1_id }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.expedition_date") }}</h3>
                  {{ report.guardian1_expedition_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.date_birth") }}</h3>
                  {{ report.guardian1_birth_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.country") }}</h3>
                  {{ countryName(report.guardian1_country_birth) }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.state") }}</h3>
                  {{
                    stateName(
                      report.guardian1_state_birth,
                      report.guardian1_country_birth
                    )
                  }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.city") }}</h3>
                  {{
                    cityName(
                      report.guardian1_city_birth,
                      report.guardian1_state_birth
                    )
                  }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian1_email") }}</h3>
                  {{ report.guardian1_email }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_cellphone") }}
                  </h3>
                  {{ report.guardian1_cellphone }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.gender") }}</h3>
                  {{ report.guardian1_gender }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.home_address") }}</h3>
                  {{ report.guardian1_address }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.religion") }}</h3>
                  {{ report.guardian1_religion }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.nationality") }}</h3>
                  {{ report.guardian1_nationality }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>Foto</h3>
                  <a
                    v-if="report.guardian1_photo"
                    :href="report.guardian1_photo"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.document") }}</h3>
                  <a
                    v-if="report.guardian1_document"
                    :href="report.guardian1_document"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.work_letter") }}</h3>
                  <a
                    v-if="report.guardian1_employment_letter"
                    :href="report.guardian1_employment_letter"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
              </v-layout>
              <h2 class="text-xs-center my-3">
                {{ $t("admissions.titles.professional_info") }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_profession") }}
                  </h3>
                  {{ report.guardian1_profession }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.employee") }}</h3>
                  {{ report.guardian1_employed }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.independent") }}</h3>
                  {{ report.guardian1_independent }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.ocupation") }}</h3>
                  {{ report.guardian1_ocupation }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.position") }}</h3>
                  {{ report.guardian1_position }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company_time") }}</h3>
                  {{ report.guardian1_time }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company") }}</h3>
                  {{ report.guardian1_company }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company_contact") }}</h3>
                  {{ report.guardian1_company_contact }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.phone_number") }}</h3>
                  {{ report.guardian1_company_number }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>Email</h3>
                  {{ report.guardian1_company_email }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.website") }}</h3>
                  {{ report.guardian1_company_web }}
                </v-flex>
              </v-layout>
              <h2 class="text-xs-center my-3">
                {{ $t("admissions.titles.academic_info") }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian1_graduate") }}
                  </h3>
                  {{ report.guardian1_graduate }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian1_date") }}</h3>
                  {{ report.guardian1_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.secondary_school") }}</h3>
                  {{ report.guardian1_school }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian1_date") }}</h3>
                  {{ report.guardian1_school_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.university") }}</h3>
                  {{ report.guardian1_college }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian1_date") }}</h3>
                  {{ report.guardian1_college_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.university_degree") }}</h3>
                  {{ report.guardian1_title }}
                </v-flex>
              </v-layout>

              <hr class="my-3" />
              <h2 class="font-weight-regular">Información del Acudiente 2</h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_first_name") }}
                  </h3>
                  {{ report.guardian2_first_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_last_name") }}
                  </h3>
                  {{ report.guardian2_last_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_relation") }}
                  </h3>
                  {{ report.guardian2_relation }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.doc_type") }}</h3>
                  {{ report.guardian2_document_type }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian2_id") }}</h3>
                  {{ report.guardian2_id }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.expedition_date") }}</h3>
                  {{ report.guardian2_expedition_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.date_birth") }}</h3>
                  {{ report.guardian2_birth_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.country") }}</h3>
                  {{ countryName(report.guardian2_country_birth) }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.state") }}</h3>
                  {{
                    stateName(
                      report.guardian2_state_birth,
                      report.guardian2_country_birth
                    )
                  }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.city") }}</h3>
                  {{
                    cityName(
                      report.guardian2_city_birth,
                      report.guardian2_state_birth
                    )
                  }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian2_email") }}</h3>
                  {{ report.guardian2_email }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_cellphone") }}
                  </h3>
                  {{ report.guardian2_cellphone }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.gender") }}</h3>
                  {{ report.guardian2_gender }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.home_address") }}</h3>
                  {{ report.guardian2_address }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.religion") }}</h3>
                  {{ report.guardian2_religion }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.nationality") }}</h3>
                  {{ report.guardian2_nationality }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>Foto</h3>
                  <a
                    v-if="report.guardian2_photo"
                    :href="report.guardian2_photo"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.document") }}</h3>
                  <a
                    v-if="report.guardian2_document"
                    :href="report.guardian2_document"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.work_letter") }}</h3>
                  <a
                    v-if="report.guardian2_employment_letter"
                    :href="report.guardian2_employment_letter"
                    target="_blank"
                    >Descargar</a
                  >
                </v-flex>
              </v-layout>
              <h2 class="text-xs-center my-3">
                {{ $t("admissions.titles.professional_info") }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_profession") }}
                  </h3>
                  {{ report.guardian2_profession }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.employee") }}</h3>
                  {{ report.guardian2_employed }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.independent") }}</h3>
                  {{ report.guardian2_independent }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.ocupation") }}</h3>
                  {{ report.guardian2_ocupation }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.position") }}</h3>
                  {{ report.guardian2_position }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company_time") }}</h3>
                  {{ report.guardian2_time }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company") }}</h3>
                  {{ report.guardian2_company }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.company_contact") }}</h3>
                  {{ report.guardian2_company_contact }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.phone_number") }}</h3>
                  {{ report.guardian2_company_number }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>Email</h3>
                  {{ report.guardian2_company_email }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.website") }}</h3>
                  {{ report.guardian2_company_web }}
                </v-flex>
              </v-layout>
              <h2 class="text-xs-center my-3">
                {{ $t("admissions.titles.academic_info") }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>
                    {{ $t("admissions.entries.form.guardian2_graduate") }}
                  </h3>
                  {{ report.guardian2_graduate }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian2_date") }}</h3>
                  {{ report.guardian2_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.secondary_school") }}</h3>
                  {{ report.guardian2_school }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian2_date") }}</h3>
                  {{ report.guardian2_school_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.university") }}</h3>
                  {{ report.guardian2_college }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.guardian2_date") }}</h3>
                  {{ report.guardian2_college_date }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.university_degree") }}</h3>
                  {{ report.guardian2_title }}
                </v-flex>
              </v-layout>

              <hr class="my-3" />
              <h2 class="font-weight-regular">
                {{ $t(`admissions.form.payment_responsible`) }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.payment_responsible") }}</h3>
                  {{ report.payment_responsible }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.doc_type") }}</h3>
                  {{ report.other_document_type }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.id") }}</h3>
                  {{ report.other_id }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.date_birth") }}</h3>
                  {{ report.other_birth_date }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.other_first_name") }}</h3>
                  {{ report.other_first_name }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.other_last_name") }}</h3>
                  {{ report.other_last_name }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.other_cellphone") }}</h3>
                  {{ report.other_cellphone }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.other_email") }}</h3>
                  {{ report.other_email }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("register_form.country") }}</h3>
                  {{ countryName(report.other_country) }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("register_form.state") }}</h3>
                  {{ stateName(report.other_state, report.other_country) }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("register_form.city") }}</h3>
                  {{ cityName(report.other_city, report.other_state) }}
                </v-flex>
                <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                  <h3>{{ $t("admissions.form.other_address") }}</h3>
                  {{ report.other_address }}
                </v-flex>
              </v-layout>

              <hr class="my-3" />
              <h2 class="font-weight-regular">
                {{ $t(`admissions.titles.additional_info`) }}
              </h2>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.first_language") }}</h3>
                  {{ report.first_language }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.wait_list") }}</h3>
                  {{ report.wait_list }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.wait_list_name") }}</h3>
                  {{ report.wait_list_name }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.previous_process") }}</h3>
                  {{ report.previous_process }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.tcs_description") }}</h3>
                  {{ report.tcs_description }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.question") }}</h3>
                  {{ report.question }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.entries.form.meeting") }}</h3>
                  <span v-if="report.meeting" class="text-xs-center">{{
                    report.meeting.description
                  }}</span>
                </v-flex>
                <v-flex xs12 px-1>
                  <h3>{{ $t("admissions.form.notes") }}</h3>
                  {{ report.notes }}
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.family_tcs") }}</h3>
                  {{ report.family_tcs }}
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="report.family_tcs === 'Si'">
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.full_name") }}</h3>
                  {{ report.family_tcs_name1 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.relation") }}</h3>
                  {{ report.family_tcs_relation1 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.grade") }}</h3>
                  {{ report.family_tcs_grade1 }}
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="report.family_tcs === 'Si'">
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.full_name") }}</h3>
                  {{ report.family_tcs_name2 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.relation") }}</h3>
                  {{ report.family_tcs_relation2 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.grade") }}</h3>
                  {{ report.family_tcs_grade2 }}
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.siblings_not_tcs") }}</h3>
                  {{ report.other_schools }}
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="report.other_schools === 'Si'">
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.full_name") }}</h3>
                  {{ report.other_school_name1 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.grade") }}</h3>
                  {{ report.other_school_grade1 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.school") }}</h3>
                  {{ report.other_school_school1 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.city") }}</h3>
                  {{ report.other_school_city1 }}
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="report.other_schools === 'Si'">
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.full_name") }}</h3>
                  {{ report.other_school_name2 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.grade") }}</h3>
                  {{ report.other_school_grade2 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("admissions.form.school") }}</h3>
                  {{ report.other_school_school2 }}
                </v-flex>
                <v-flex xs3 px-1>
                  <h3>{{ $t("register_form.city") }}</h3>
                  {{ report.other_school_city2 }}
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 px-1>
                  <h3>{{ $t("admissions.form.important_factor") }}</h3>
                  {{ report.why_tcs }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 px-1 text-xs-center>
              <div v-if="report.family_id" class="sticky">
                <v-btn @click="getBitacora(report.family_id)" color="primary">
                  Bitácora
                </v-btn>
                <br /><br />
                <v-btn @click="getReferences(report.family_id)" color="primary">
                  Referencias
                </v-btn>
                <br /><br />
                <v-btn
                  @click="getRecommendations(report.family_id)"
                  color="primary"
                >
                  Recomendaciones
                </v-btn>
                <br /><br />
                <v-btn @click="getScore(report.id)" color="primary">
                  Calificación
                </v-btn>
                <br /><br />
                <v-btn @click="counsel_dialog = true" color="primary">
                  Consejería
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row>
      <v-flex xs2 px-1>
        <v-select
          v-model="cohort_filter"
          :items="cohort_options"
          label="Cohorte"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 px-1>
        <v-select
          v-model="meeting_filter"
          :items="meeting_options"
          label="Reunión"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 px-1>
        <v-select
          v-model="vinculada_filter"
          :items="general_options"
          label="Vinculada"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 px-1>
        <v-select
          v-model="staff_filter"
          :items="staff_options"
          label="Staff"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 px-1>
        <v-select
          v-model="graduate_filter"
          :items="general_options"
          label="Egresados"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 px-1>
        <v-select
          v-model="twin_filter"
          :items="general_options"
          label="Mellizo"
          clearable
        ></v-select>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="entries_to_show"
      :loading="loadingTable"
      class="elevation-1"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ props.item.created_at.substr(0, 10) }}
        </td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="editEntry(props.item.id)"
              slot="activator"
            >
              edit
            </v-icon>
            <span>{{ $t("admissions.entries.edit") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="deleteEntry(props.item.id)"
              slot="activator"
            >
              delete
            </v-icon>
            <span>{{ $t("admissions.entries.delete") }}</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-btn @click="seeReport(props.item.id)" color="primary">
            Reporte
          </v-btn>
        </td>
        <td class="text-xs-center">{{ props.item.setting != null ? props.item.setting.description : '' }}</td>
        <td class="text-xs-center">{{ props.item.current_step }}</td>
        <td v-if="props.item.score" class="text-xs-center">
          {{ props.item.score.average }}
        </td>
        <td v-else class="text-xs-center">0</td>
        <td class="text-xs-center">{{ props.item.vinculada }}</td>
        <td v-if="props.item.family" class="text-xs-center">
          {{ props.item.family.employee }}
        </td>
        <td v-else class="text-xs-center"></td>
        <td class="text-xs-center">{{ props.item.full_name }}</td>
        <td class="text-xs-center">{{ props.item.nuip }}</td>
        <td class="text-xs-center">{{ props.item.date_of_birth }}</td>
        <td v-if="props.item.rc" class="text-xs-center">
          <a :href="props.item.rc" target="_blank">Descargar</a>
        </td>
        <td v-else class="text-xs-center"></td>
        <td class="text-xs-center">{{ props.item.twin }}</td>
        <td class="text-xs-center">{{ props.item.gender }}</td>
        <td class="text-xs-center">{{ props.item.guardian1_first_name }}</td>
        <td class="text-xs-center">{{ props.item.guardian1_last_name }}</td>
        <td class="text-xs-center">{{ props.item.guardian1_relation }}</td>
        <td class="text-xs-center">{{ props.item.guardian1_graduate }}</td>
        <td class="text-xs-center">{{ props.item.guardian2_first_name }}</td>
        <td class="text-xs-center">{{ props.item.guardian2_last_name }}</td>
        <td class="text-xs-center">{{ props.item.guardian2_relation }}</td>
        <td class="text-xs-center">{{ props.item.guardian2_graduate }}</td>
        <td class="text-xs-center">{{ props.item.meeting != null ? props.item.meeting.description: '' }}</td>
                <!-- <td v-if="props.item.meeting" class="text-xs-center">{{ props.item.meeting.description }}</td>
                <td v-else class="text-xs-center"></td> -->
      </template>
    </v-data-table>
    <v-dialog
      v-model="bitacora_dialog"
      transition="dialog-transition"
      max-width="1280px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="bitacora_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Bitácora</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <bitacora
          :bitacora="bitacora"
          v-on:fetchBitacora="fetchBitacora"
          :family_id="family_id"
        >
        </bitacora>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rec_dialog"
      transition="dialog-transition"
      max-width="1280px"
      overlay-color="white"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="rec_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Recomendaciones</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <recommendations
        :recommendations="recommendations"
        :family_id="family_id"
      ></recommendations>
    </v-dialog>
    <v-dialog
      v-model="ref_dialog"
      transition="dialog-transition"
      max-width="1280px"
      overlay-color="white"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="ref_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Referencias</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <references :references="references" :family_id="family_id"></references>
    </v-dialog>
    <v-dialog
      v-if="score"
      v-model="score_dialog"
      transition="score-transition"
      max-width="1280px"
      overlay-color="white"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="score_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Puntuación</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <score :score="score" :settings="settings" evaluator="admissions"></score>
    </v-dialog>
    <v-dialog
      v-if="report.family_id"
      v-model="counsel_dialog"
      transition="score-transition"
      max-width="1280px"
      overlay-color="white"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="counsel_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Reporte Consejería</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <counsel :family="report"></counsel>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Form from "vform";
import FileUpload from "vue-upload-component";
import JsonExcel from "vue-json-excel";
import bitacora from "./bitacora";
import recommendations from "./recommendations";
import references from "./references";
import score from "./score";
import counsel from "./counsel_report";
export default {
  name: "admission-entries",
  components: {
    FileUpload,
    "download-excel": JsonExcel,
    bitacora: bitacora,
    recommendations: recommendations,
    references: references,
    score: score,
    counsel: counsel
  },
  data() {
    return {
      loadingFamilies: false,
      loadingFamiliesInvitation: false,
      loadingFamiliesCouncil: false,
      dialogFamily: false,
      familiesToCreate: [],
      familiesInvitation: [],
      familiesCouncilInvitation: [],
      dialogInvitation: false,
      dialogCouncil: false,
      headers: [
        {
          text: this.$t("admissions.entries.form.date"),
          align: "center",
          value: "created_at"
        },
        {
          text: this.$t("admissions.entries.form.actions"),
          align: "center",
          value: "",
          sortable: false
        },
        { text: "Reporte", align: "center", value: "", sortable: false },
        {
          text: this.$t("admissions.entries.form.cohort"),
          align: "center",
          value: "meeting.setting.description"
        },
        { text: "Paso", align: "center", value: "current_step" },
        { text: "Promedio", align: "center", value: "score.average" },
        {
          text: this.$t("admissions.entries.form.vinculada"),
          align: "center",
          value: "vinculada"
        },
        {
          text: this.$t("admissions.entries.form.employee"),
          align: "center",
          value: "family.employee"
        },
        {
          text: this.$t("admissions.entries.form.first_name"),
          align: "center",
          value: "full_name"
        },
        {
          text: this.$t("admissions.entries.form.nuip"),
          align: "center",
          value: "nuip"
        },
        {
          text: this.$t("admissions.entries.form.date_of_birth"),
          align: "center",
          value: "date_of_birth"
        },
        {
          text: this.$t("admissions.entries.form.rc"),
          align: "center",
          value: "rc"
        },
        {
          text: this.$t("admissions.entries.form.twin"),
          align: "center",
          value: "twin"
        },
        {
          text: this.$t("admissions.entries.form.gender"),
          align: "center",
          value: "gender"
        },
        {
          text: this.$t("admissions.entries.form.guardian1_first_name"),
          align: "center",
          value: "guardian1_first_name"
        },
        {
          text: this.$t("admissions.entries.form.guardian1_last_name"),
          align: "center",
          value: "guardian1_last_name"
        },
        {
          text: this.$t("admissions.entries.form.guardian1_relation"),
          align: "center",
          value: "guardian1_relation"
        },
        {
          text: this.$t("admissions.entries.form.guardian1_graduate"),
          align: "center",
          value: "guardian1_graduate"
        },
        {
          text: this.$t("admissions.entries.form.guardian2_first_name"),
          align: "center",
          value: "guardian2_first_name"
        },
        {
          text: this.$t("admissions.entries.form.guardian2_last_name"),
          align: "center",
          value: "guardian2_last_name"
        },
        {
          text: this.$t("admissions.entries.form.guardian2_relation"),
          align: "center",
          value: "guardian2_relation"
        },
        {
          text: this.$t("admissions.entries.form.guardian2_graduate"),
          align: "center",
          value: "guardian2_graduate"
        },
        {
          text: this.$t("admissions.entries.form.meeting"),
          align: "center",
          value: "meeting"
        }
      ],
      entry: [],
      entries_to_show: [],
      typesItems: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      dialogReport: false,
      disabled_date: false,
      bitacora_dialog: false,
      rec_dialog: false,
      ref_dialog: false,
      score_dialog: false,
      counsel_dialog: false,
      bitacora: [],
      recommendations: [],
      references: [],
      score: null,
      settings: null,
      family_id: "",
      entry_id: 0,
      family_name: "",
      countries: [],
      states: [],
      cities: [],
      egresado: false,
      guardian1_graduate: "No",
      guardian2_graduate: "No",
      pagination: {
        rowsPerPage: 5
      },

      form: new Form({
        vinculada: "No",
        first_name: "",
        last_name: "",
        nuip: "",
        original_nuip: "",
        date_of_birth: "",
        twin: "No",
        twin_first_name: "",
        twin_last_name: "",
        twin_nuip: "",
        twin_gender: "",
        gender: "",
        guardian1_first_name: "",
        guardian1_last_name: "",
        guardian1_id: "",
        guardian1_cellphone: "",
        guardian1_email: "",
        guardian1_relation: "",
        guardian1_profession: "",
        guardian1_ocupation: "",
        guardian1_company: "",
        guardian1_graduate: "No",
        guardian1_date: "",
        guardian2_first_name: "",
        guardian2_last_name: "",
        guardian2_id: "",
        guardian2_cellphone: "",
        guardian2_email: "",
        guardian2_relation: "",
        guardian2_profession: "",
        guardian2_ocupation: "",
        guardian2_company: "",
        guardian2_graduate: "No",
        guardian2_date: "",
        first_language: "",
        wait_list: "No",
        wait_list_name: "",
        previous_process: "No",
        tcs_description: "",
        question: "",
        meeting_id: "",
        notes: ""
      }),
      showSucessMessage: false,
      editingEntry: false,
      userNameMaxLength: 60,
      entries: [],
      cohort_filter: "",
      meeting_filter: "",
      vinculada_filter: "",
      staff_filter: "",
      graduate_filter: "",
      twin_filter: "",
      cohort_options: [],
      meeting_options: [],
      general_options: [
        { value: "Si", text: "Si" },
        { value: "No", text: "No" }
      ],
      staff_options: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" }
      ],
      report: {}
    };
  },
  computed: {
    entryResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + "..."
          : user.name;

        return Object.assign({}, user);
      });
    }
  },
  watch: {
    dialogFamily(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.loadingFamilies = true;
        console.log("this.loadingFamilies", this.loadingFamilies);
        this.getFamiliesToCreate();
      }
    },
    dialogInvitation(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.loadingFamiliesInvitation = true;
        this.getFamiliesInvitation();
      }
    },
    dialogCouncil(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.loadingFamiliesCouncil = true;
        this.getFamiliesCouncilInvitation();
        // console.log("this.loadingFamilies",this.loadingFamilies)
        // this.getFamiliesToCreate();
      }
    },
    cohort_filter() {
      this.filter_entries();
    },
    meeting_filter() {
      this.filter_entries();
    },
    vinculada_filter() {
      this.filter_entries();
    },
    staff_filter() {
      this.filter_entries();
    },
    graduate_filter() {
      this.filter_entries();
    },
    twin_filter() {
      this.filter_entries();
    },
    dialog(val) {
      val || this.close();
    },
    dialogReport(val) {
      val || this.close();
    },
    guardian1_graduate(newValue) {
      this.form.guardian1_graduate = newValue;
      this.egresado =
        newValue == "Si" || this.form.guardian2_graduate == "Si" ? true : false;
    },
    guardian2_graduate(newValue) {
      this.form.guardian2_graduate = newValue;
      this.egresado =
        newValue == "Si" || this.form.guardian1_graduate == "Si" ? true : false;
    }
  },
  created() {
    this.getEntry();
    //this.getFamiliesCouncilInvitation();
    // familiesToCreate: [],
    //   familiesInvitation: [],
    //   familiesCouncilInvitation: [],
  },
  methods: {
    handleDialogFamily() {
      // this.getFamiliesToCreate();
      this.dialogFamily = false;
    },
    handleDialogInvitation() {
      this.dialogInvitation = false;
    },
    handleDialogCouncil() {
      this.dialogCouncil = false;
    },
    filter_entries() {
      let entries_to_show = this.entry;

      if (this.cohort_filter && this.cohort_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry => entry.setting.id == this.cohort_filter
        );
      }

      if (this.meeting_filter && this.meeting_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry =>
            entry.meeting != null && entry.meeting.id == this.meeting_filter
        );
      }

      if (this.vinculada_filter && this.vinculada_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry => entry.vinculada == this.vinculada_filter
        );
      }

      if (this.staff_filter && this.staff_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry =>
            entry.family != null && entry.family.employee == this.staff_filter
        );
      }

      if (this.graduate_filter && this.graduate_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry =>
            entry.guardian1_graduate == this.graduate_filter ||
            entry.guardian2_graduate == this.graduate_filter
        );
      }

      if (this.twin_filter && this.twin_filter !== "") {
        entries_to_show = entries_to_show.filter(
          entry => entry.twin == this.twin_filter
        );
      }

      this.entries_to_show = entries_to_show;
    },
    async getFamiliesToCreate() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        await axios
          .get(`/api/admissions/get_families_to_create/${this.cohort_filter}`)
          .then(resp => {
            if (resp.status === 200) {
              this.familiesToCreate = resp.data;
              this.loadingFamilies = false;
              // console.log("this.loadingFamilies",this.loadingFamilies)
            }
          })
          .catch(error => console.log(error));
      } else {
        await axios
          .get(`/api/admissions/get_families_to_create`)
          .then(resp => {
            if (resp.status === 200) {
              this.familiesToCreate = resp.data;
              this.loadingFamilies = false;
              // console.log("this.loadingFamilies",this.loadingFamilies)
            }
          });
      }
    },
    async getEntry() {
      this.loadingTable = true;

      axios
        .get("/api/admissions/get_settings")
        .then(resp => {
          if (resp.status === 200) {
            this.settings = resp.data[0];
          }
        })
        .catch(error => console.log(error));

      let { data } = await axios.get("/api/admissions/entries");
      this.entry = data;
      this.entries_to_show = data;
      this.loadingTable = false;

      const settings = await axios.get("/api/admissions/settings");
      settings.data.forEach(setting => {
        this.cohort_options.push({
          value: setting.id,
          text: setting.description
        });
      });

      const meetings = await axios.get("/api/admissions/meetings");
      meetings.data.forEach(meeting => {
        this.meeting_options.push({
          value: meeting.id,
          text: meeting.description
        });
      });
      axios
        .get("/api/countries")
        .then(resp => {
          if (resp.status === 200) {
            this.countries = resp.data.countries;
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/states")
        .then(resp => {
          if (resp.status === 200) {
            this.states = resp.data.states;
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/cities")
        .then(resp => {
          if (resp.status === 200) {
            this.cities = resp.data.cities;
          }
        })
        .catch(error => console.log(error));
    },
    close() {
      this.dialog = false;
      this.editingEntry = false;
      this.entries = [];
    },
    async createFamilies() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        const result = await axios.get(`/api/admissions/create_families/${this.cohort_filter}`);
        if (result.status === 200) {
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Familias Creadas",
            modal: false
          });
        }
      } else {
        const result = await axios.get(`/api/admissions/create_families`);
        if (result.status === 200) {
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Invitaciones Enviadas",
            modal: false
          });
        }
      }

      this.dialogFamily = false;

      this.close();
    },
    async getFamiliesInvitation() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        await axios
          .get(`/api/admissions/get_families_invitation/${this.cohort_filter}`)
          .then(resp => {
            if (resp.status === 200) {
              this.familiesInvitation = resp.data;
              this.loadingFamiliesInvitation = false;
              // console.log("familiesInvitation", this.familiesInvitation);
            }
          });
      } else {
        await axios
          .get("/api/admissions/get_families_invitation")
          .then(resp => {
            if (resp.status === 200) {
              this.familiesInvitation = resp.data;
              this.loadingFamiliesInvitation = false;
              // console.log("familiesInvitation", this.familiesInvitation);
            }
          });
      }
    },
    async getFamiliesCouncilInvitation() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        await axios
          .get(
            `/api/admissions/get_families_council_invitation/${this.cohort_filter}`
          )
          .then(resp => {
            if (resp.status === 200) {
              this.familiesCouncilInvitation = resp.data;
              console.log("familiesCouncilInvitation", this.familiesInvitation);
            }
          });
      } else {
        await axios
          .get("/api/admissions/get_families_council_invitation")
          .then(resp => {
            if (resp.status === 200) {
              this.familiesCouncilInvitation = resp.data;
              console.log("familiesCouncilInvitation", this.familiesInvitation);
            }
          });
      }
    },
    async sendInvitation() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        const result = await axios.get(
          `/api/admissions/send_invitation/${this.cohort_filter}`
        );
        if (result.status === 200) {
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Invitaciones Enviadas",
            modal: false
          });
        }
      } else {
        const result = await axios.get("/api/admissions/send_invitation");
        if (result.status === 200) {
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "Invitaciones Enviadas",
            modal: false
          });
        }
      }

      this.dialogInvitation = false;
      this.close();
    },
    async sendCouncilInvitation() {
      if (this.cohort_filter && this.cohort_filter !== "") {
        const result = await axios.get(
          `/api/admissions/send_council_invitation/${this.cohort_filter}`
        );
        if (result.status === 200) {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Invitaciones Enviadas",
          modal: false
        });
      }
      } else {
        const result = await axios.get(
          "/api/admissions/send_council_invitation"
        );
        if (result.status === 200) {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Invitaciones Enviadas",
          modal: false
        });
      }
      }
      this.dialogCouncil = false;
      this.close();
    },
    async saveEntry() {
      if (await this.formHasErrors()) return;

      const result = await this.form.post("/api/admissions/entries", this.form);

      if (result.status === 200) {
        this.getEntry();
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: this.$t("admissions.entries.messages.saved_ok"),
          modal: false
        });
      }

      this.close();
    },
    editEntry(id_entry) {
      const EntryToEdit = this.entry.filter(type => type.id === id_entry)[0];
      this.editingEntry = true;
      this.dialog = true;
      this.egresado =
        EntryToEdit.guardian1_graduate == "Si" ||
        EntryToEdit.guardian2_graduate == "Si"
          ? true
          : false;
      this.guardian1_graduate = EntryToEdit.guardian1_graduate;
      this.guardian2_graduate = EntryToEdit.guardian2_graduate;
      this.form = new Form({
        vinculada: EntryToEdit.vinculada == "Si" ? true : false,
        first_name: EntryToEdit.first_name,
        last_name: EntryToEdit.last_name,
        nuip: EntryToEdit.nuip,
        original_nuip: EntryToEdit.nuip,
        date_of_birth: EntryToEdit.date_of_birth,
        twin: EntryToEdit.twin,
        twin_first_name: EntryToEdit.twin_first_name,
        twin_last_name: EntryToEdit.twin_last_name,
        twin_nuip: EntryToEdit.twin_nuip,
        twin_gender: EntryToEdit.twin_gender,
        rc: EntryToEdit.rc,
        gender: EntryToEdit.gender,
        guardian1_first_name: EntryToEdit.guardian1_first_name,
        guardian1_last_name: EntryToEdit.guardian1_last_name,
        guardian1_id: EntryToEdit.guardian1_id,
        guardian1_cellphone: EntryToEdit.guardian1_cellphone,
        guardian1_email: EntryToEdit.guardian1_email,
        guardian1_relation: EntryToEdit.guardian1_relation,
        guardian1_profession: EntryToEdit.guardian1_profession,
        guardian1_ocupation: EntryToEdit.guardian1_ocupation,
        guardian1_company: EntryToEdit.guardian1_company,
        guardian1_date: EntryToEdit.guardian1_date,
        guardian2_first_name: EntryToEdit.guardian2_first_name,
        guardian2_last_name: EntryToEdit.guardian2_last_name,
        guardian2_id: EntryToEdit.guardian2_id,
        guardian2_cellphone: EntryToEdit.guardian2_cellphone,
        guardian2_email: EntryToEdit.guardian2_email,
        guardian2_relation: EntryToEdit.guardian2_relation,
        guardian2_profession: EntryToEdit.guardian2_profession,
        guardian2_ocupation: EntryToEdit.guardian2_ocupation,
        guardian2_company: EntryToEdit.guardian2_company,
        guardian2_date: EntryToEdit.guardian2_date,
        first_language: EntryToEdit.first_language,
        wait_list: EntryToEdit.wait_list,
        wait_list_name: EntryToEdit.wait_list_name,
        previous_process: EntryToEdit.previous_process,
        tcs_description: EntryToEdit.tcs_description,
        question: EntryToEdit.question,
        meeting_id: EntryToEdit.meeting_id,
        payment_responsible: EntryToEdit.payment_responsible,
        other_first_name: EntryToEdit.other_first_name,
        other_last_name: EntryToEdit.other_last_name,
        other_cellphone: EntryToEdit.other_cellphone,
        other_email: EntryToEdit.other_email,
        other_country: EntryToEdit.other_country,
        other_state: EntryToEdit.other_state,
        other_address: EntryToEdit.other_address,
        expatriado: EntryToEdit.expatriado,
        multicultural: EntryToEdit.multicultural,
        notes: EntryToEdit.notes,
        staff: EntryToEdit.family != null ? EntryToEdit.family.employee : 0,
        family_id: EntryToEdit.family_id,
        id: EntryToEdit.id
      });
    },
    seeReport(id_entry) {
      const EntryToEdit = this.entry.filter(type => type.id === id_entry)[0];
      this.dialogReport = true;
      this.report = EntryToEdit;
    },
    deleteEntry(id_entry) {
      if (confirm("¿Está seguro de que quiere eliminar esta entrada?")) {
        axios
          .delete(`/api/admissions/entries/${id_entry}`)
          .then(resp => {
            if (resp.status === 200) {
              this.getEntry();
            }
          })
          .catch(error => console.log(error));
      }
    },
    updateEntry() {
      this.form
        .put("/api/admissions/entries")
        .then(resp => {
          if (resp.data.already_exists) {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "Ya existe un registro con el mismo número de identificación.",
              modal: true
            });
          } else if (resp.status === 200) {
            this.getEntry();
            this.close();
            this.editingEntry = false;
          }
        })
        .catch(error => console.log(error));
    },
    handleEntry(id_entry, status) {
      axios
        .put("/api/admissions/entries", { id: id_entry, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.entry = this.entry.map(entry => {
              if (entry.id === id_entry) {
                entry.status = !status;
              }
              return entry;
            });
            this.entries_to_show = this.entry;
          }
        });
    },
    onlyNumbers($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 45) {
        //This is a code por - (minus sign)
        $event.preventDefault();
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log("add", newFile);
      }
      if (newFile && oldFile) {
        // update
        console.log("update", newFile);
      }
      if (!newFile && oldFile) {
        // remove
        console.log("remove", oldFile);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    getBitacora(family_id) {
      this.family_id = family_id;
      axios
        .get(`/api/admissions/bitacora/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.bitacora = resp.data;
            this.bitacora_dialog = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchBitacora() {
      this.getBitacora(this.family_id);
    },
    getRecommendations(family_id) {
      this.family_id = family_id;
      axios
        .get(`/api/admissions/recommendations_family/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.recommendations = resp.data;
            this.rec_dialog = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getReferences(family_id) {
      this.family_id = family_id;
      axios
        .get(`/api/admissions/references/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.references = resp.data;
            this.ref_dialog = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getScore(entry_id) {
      this.entry_id = entry_id;
      axios
        .get(`/api/admissions/family_score/admissions/${entry_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.score = resp.data;
            this.score_dialog = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    countryName(value) {
      if (value) {
        return this.countries.filter(country => country.value == value)[0].text;
      }
    },
    stateName(value, country) {
      if (value && country) {
        return this.states.filter(
          state => state.value == value && state.id_pais == country
        )[0].text;
      }
    },
    cityName(value, state) {
      if (value && state) {
        return this.cities.filter(
          city => city.value == value && city.id_departamento == state
        )[0].text;
      }
    }
  }
};
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.editable_image {
  display: flex;
  justify-content: space-between;
}
.sticky {
  position: sticky;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/entries.vue